import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { XXL, MD, LG } from '@zendeskgarden/react-typography';
import { ItemCol, ItemRow } from './CompanyOfferings.styles.js';


const CompanyOfferings = (props) => {
  return (
    <div style={{margin: '0 auto', maxWidth: '1100px'}}>
      <Row>
        <Col size="12" style={{marginBottom: '40px'}}>
          <div>
            <XXL bold  style={{margin: '0 auto', maxWidth: '700px'}} center paddingTopLg navy tag="h2" >Our Process And Personnel Are Proven, Trusted and Respected.</XXL>
            <LG center style={{margin: '0 auto', maxWidth: '700px'}} paddingTopMd paddingBottomLg navy light tag="h3">The Best Teams Produce the Best Results.</LG>
          </div>
        </Col>
      </Row>
      
      <ItemRow>
        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Identify Your Needs</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">Don’t buy equipment you don’t need. We’ll educate you on the actual differences between modalities so that we can fulfill your needs, strengthen your practice, attract a larger variety of patients and extend your value instead of your budget.</MD>

          </div>
        </ItemCol>


        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Reduce Risk And Protect Your Investment</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">A clear and comprehensive plan and realistic timeline will be provided to customers. MRT spearheads your project and guides your personnel from start to finish so that things are done quickly, correctly, and there is no confusion towards responsibilities. When a job is done right the first time, costly mistakes are less likely to occur. </MD>
          </div>
        </ItemCol>

        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Execution Integrity</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">MRT is able to dispatch the very best personnel in the business because they take pride in their work and reputation. They have spent decades learning from their experiences and are steadfast in fulfilling the execution integrity expected of them.</MD>
          </div>
        </ItemCol>

        <ItemCol size="12" md={6} style={{marginBottom: 0}} >
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">First Rate Results</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">MRT is trusted by some of the most esteemed hospitals in the world because of our dedication to excellence. Your equipment and project will be handled deliberately and carefully to completion. Whether a major global hospital, multi-facility network or stand alone private practice, MRT will give you the tools to succeed and prosper.  
            </MD>
          </div>
        </ItemCol>

      </ItemRow>
    </div>
  )
}


export default CompanyOfferings;
